var _a;
const u = up.util;
const e = up.element;
up.LayerLookup = (_a = class LayerLookup {
        constructor(stack, options) {
            this._stack = stack;
            if (options.normalizeLayerOptions !== false) {
                up.layer.normalizeOptions(options);
            }
            this._options = options;
            this._values = u.getSimpleTokens(options.layer);
        }
        all() {
            let results = u.flatMap(this._values, (value) => this._resolveValue(value));
            results = u.compact(results);
            results = u.uniq(results);
            return results;
        }
        static all(stack, ...args) {
            const options = u.parseArgIntoOptions(args, 'layer');
            const { layer } = options;
            if (layer instanceof up.Layer) {
                return [layer];
            }
            return new this(stack, options).all();
        }
        _forElement(element) {
            element = e.get(element);
            return u.find(this._stack.reversed(), (layer) => layer.contains(element));
        }
        _forIndex(value) {
            return this._stack.at(value);
        }
        _resolveValue(value) {
            if (value instanceof up.Layer) {
                return value;
            }
            if (u.isNumber(value)) {
                return this._forIndex(value);
            }
            if (/^\d+$/.test(value)) {
                return this._forIndex(Number(value));
            }
            if (u.isElementLike(value)) {
                return this._forElement(value);
            }
            switch (value) {
                case 'any':
                    return [this._getBaseLayer(), ...this._stack.reversed()];
                case 'current':
                    return this._getBaseLayer();
                case 'closest':
                    return this._stack.selfAndAncestorsOf(this._getBaseLayer());
                case 'parent':
                    return this._getBaseLayer().parent;
                case 'ancestor':
                case 'ancestors':
                    return this._getBaseLayer().ancestors;
                case 'child':
                    return this._getBaseLayer().child;
                case 'descendant':
                case 'descendants':
                    return this._getBaseLayer().descendants;
                case 'subtree':
                    return this._getBaseLayer().subtree;
                case 'new':
                    return 'new';
                case 'root':
                    return this._stack.root;
                case 'overlay':
                case 'overlays':
                    return this._stack.overlays.toReversed();
                case 'front':
                    return this._stack.front;
                case 'origin':
                    return this._getOriginLayer();
                default:
                    return up.fail("Unknown { layer } option: %o", value);
            }
        }
        _getOriginLayer() {
            let { origin, originLayer } = this._options;
            if (originLayer) {
                return originLayer;
            }
            if (origin) {
                return this._forElement(origin);
            }
        }
        _getBaseLayer() {
            let { baseLayer } = this._options;
            if (u.isString(baseLayer)) {
                const recursiveOptions = { ...this._options, baseLayer: this._stack.current, normalizeLayerOptions: false, layer: baseLayer };
                return this.constructor.all(this._stack, recursiveOptions)[0];
            }
            else {
                return baseLayer || this._getOriginLayer() || this._stack.current;
            }
        }
    },
    (() => {
        u.memoizeMethod(_a.prototype, {
            _getBaseLayer: true,
            _getOriginLayer: true,
        });
    })(),
    _a);
